import { createSelector } from 'reselect';

export const menusSelector = state => state.menus;
export const menusEntitiesSelector = createSelector(
  menusSelector,
  menus => menus.entities,
);
